import * as React from 'react';
import styled from 'styled-components';
import { color } from 'styled-system';

type SideBarWrapperProps = {
  open: boolean;
  className?: string;
  children: React.ReactNode;
};

type LogoContProps = {
  isWeb?: boolean;
  open: boolean;
};

type LogoProps = {
  open: boolean;
  src: string;
};

export const PageWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  box-sizing: border-box;
`;

export const SideBarWrapper = styled.div<SideBarWrapperProps>`
  ${color};
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  position: fixed;
  max-width: 100%;
  height: calc(100vh / var(--ib-ui-scale, 1));
  max-height: calc(100vh / var(--ib-ui-scale, 1));
  box-sizing: border-box;
  width: ${props => (props.open ? '250px' : '60px')};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  background: ${props => props.theme.colors.primary};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-shadow: 1px 0px 5px 1px rgba(0, 0, 0, 0.15);
  & .sidebar-menu-icon {
    font-size: 21px;
    margin-left: 20px;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  & .nav-link-text-hidden > div > span {
    opacity: 0;
    visibility: hidden;
    width: 0;
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const Logo = styled.img<LogoProps>`
  height: auto;
  max-width: 100%;
  display: inline-block;
  width: ${props => (props.open ? '60%' : 0)};
  /* sits just after the hamburger rather than pushed to the far edge of the bar (IB-1885) */
  margin: ${props => (props.open ? '0 16px 0 24px' : '0 -15px 0 0')};
  /* an organisation uploads a logo of any shape, and a tall one would otherwise
     stretch the 70px bar - letterbox it instead of letting it grow */
  max-height: 50px;
  object-fit: contain;
  object-position: left center;
`;

export const LogoCont = styled.div<LogoContProps>`
  height: 70px;
  z-index: 200;
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  border-bottom: ;
  border-bottom: ${props => (props.isWeb ? '1px solid' : `1px solid ${props.theme.colors.textDefault}`)};
  transition-property: width;
  justify-content: flex-start;
  width: ${props => (props.open ? '250px' : '60px')};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  & ${Logo} {
    transition-property: visibility, opacity;
    opacity: ${props => (props.open ? 1 : 0)};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    visibility: ${props => (props.open ? 'visible' : 'hidden')};
  }
`;

export const MobileAccountImageContainer = styled.div`
  height: 80px;
  z-index: 200;
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #e0e0e0;
  transition-property: width;
  justify-content: space-between;
  padding: 0 15px;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  width: 100%;
`;

export const MobileHamburgerCont = styled.div<LogoContProps>`
  height: 70px;
  z-index: 200;
  display: flex;
  position: absolute;
  align-items: center;
  box-sizing: border-box;
  transition-property: width;
  justify-content: space-between;
  width: ${props => (props.open ? '60px' : '60px')};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
`;

export const SideBarContent = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 0;
`;
